import React from 'react';
import PropTypes from 'prop-types';

import Banner from './Banner';
import { useBannerContext } from '../../common/contexts/BannerContext';
import { useAppContext } from '../../common/contexts/AppContext';

const FNLBanner = ({ studentUid }) => {
    const bannerContext = useBannerContext();
    const { classId } = useAppContext();
    const {
        actions: { hideFNLBanner },
        isBannerVisible,
    } = bannerContext;

    const dismissHandler = () =>
        hideFNLBanner({
            classId,
            studentUid,
        });

    const isFNLBannerVisible = isBannerVisible(classId, studentUid, 'isFNLBannerVisible');

    return isFNLBannerVisible ? (
        <Banner
            isInformation
            isDismissible
            dismissHandler={dismissHandler}
            className='dashboard-section dashboard-bm-section dashboard-decrease-padding'
        >
            <div>
                <div className='dashboard-title'>FNL</div>
                <div className='dashboard-text dashboard-fnl-text'>
                    FNL no es requerida para el puntaje compuesto de 2
                    <div className='dashboard-sup-container'>
                        <div className='dashboard-sup-elem'>o</div>
                    </div>
                    &nbsp;grado. Está disponible como apoyo a las pautas de diagnóstico de dislexia
                    de su distrito. Refiérase a la guía de su distrito sobre pruebas adicionales
                    para 2
                    <div className='dashboard-sup-container'>
                        <div className='dashboard-sup-elem'>o</div>
                    </div>
                    &nbsp;grado.
                </div>
            </div>
        </Banner>
    ) : null;
};

FNLBanner.propTypes = {
    studentUid: PropTypes.string.isRequired,
};

export default FNLBanner;
